export interface cityBaseViewModel {
    createdByUserId: string;
    modifiedByUserId: string;
    createdByUserName: string;
    modifiedByUserName: string;
    dateCreated: string;
    dateModified: string;
}
export interface cityViewModel extends cityBaseViewModel {
    cityId: string;
    cityName: string;
    isActive: boolean;
    stateId: string;
    stateName: string;
    timezoneName: string;
    baseCityId: string;
    cityType: string;
    isTravelCost: boolean | null;
    cityLunchTime: number | null;
    countryId: string;
    countryName: string;
    baseCityName: string;
    cityTypeDisplayName: string;
    isTravelCostTextValue: string;
    isSubContractorCity: boolean;
    subContractorName: string;
    cityManagerName: string;
    isSubContractorUser: boolean;
    isDefaultCMUser: boolean;
    isBaseCityStateDiff: boolean;
    baseCityStateId: string;
    lat: number | null;
    lng: number | null;
    timezoneLabel: string;
    cityHolidayList: cityHolidayListDTO[];
}

export class cityType {
    cityTypeKey: string | undefined;
    cityTypeDisplayName: string | undefined;
    isSubContractorCity: boolean | undefined;
}
export class cityLunchTime {
    cityLunchTimeKey: number | undefined;
    cityLunchTimeDisplayName: string | undefined;
}
export interface cityShortViewModel {
    cityId: string,
    cityName: string,
    baseCityId: string,
    cityType: string,
    isActive: boolean,
    isSubContractorCity: boolean,
    isSubContractorCityText: string;
    stateId: string;
    stateName: string;
    isSelected: boolean;
    cityTypeDisplayName: string;
}
export class cityCreateDTO {
    cityType: string | undefined;
    cityName: string | undefined;
    stateId: string | undefined;
    lunchTime: number | undefined;
    isSubContractorCity: boolean | undefined;
    isActive: boolean | undefined;
    isTravelCost: boolean | undefined;
    baseCityId: string | undefined;
    lat: number | undefined;
    lng: number | undefined;
    timezoneLabel: string | undefined;
    timezone: string | undefined;
    cityHolidayList: cityHolidayListDTO[] = [];
}
export class cityHolidayListDTO {
    holidayId: string | undefined;
    isNotObserved: boolean | undefined;
}
export class cityUpdateDTO {
    cityId: string | undefined;
    cityType: string | undefined;
    cityName: string | undefined;
    stateId: string | undefined;
    lunchTime: number | undefined;
    isSubContractorCity: boolean | undefined;
    isActive: boolean | undefined;
    isTravelCost: boolean | undefined;
    baseCityId: string | undefined;
    lat: number | undefined;
    lng: number | undefined;
    timezoneLabel: string | undefined;
    timezone: string | undefined;
    soIds: string[] | undefined;
    cityHolidayList: cityHolidayListDTO[] = [];
    cityHolidayListForDelete: cityHolidayListDTO[] = [];
}
export class cityHolidayUpdateDTO {
    cityId: string | undefined;
    cityHolidayList: cityHolidayListDTO[] = [];
    cityHolidayListForDelete: cityHolidayListDTO[] = [];
}
export class cityListExportToExcel {
    public "City Name": string;
    public "City Type": string;
    public "Base City": string;
    public "Is Travel Cost": string;
    public "State": string;
    public "Country": string;


    constructor(cityDto: cityViewModel) {
        this["City Name"] = cityDto.cityName;
        this["City Type"] = cityDto.cityTypeDisplayName;
        this["Base City"] = cityDto.baseCityName;
        this["Is Travel Cost"] = cityDto.isTravelCostTextValue;
        this["State"] = cityDto.stateName;
        this["Country"] = cityDto.countryName;
    }
}
export interface cityWithStateViewModel {
    cityId: string;
    baseCityId: string;
    cityName: string;
    isActive: boolean;
    stateId: string;
    stateName: string;
    isSubContractorCity: boolean | null;
    cityType: string;
    cityTypeDisplayName: string;
    isSelected: boolean;
}

export interface cityListByStateIdsDTO {
    stateIds: string[];
}